import { useAppLayout } from '@/components/AppLayout/AppLayoutProvider'
import SoundButton from '@/components/Button/SoundButton'
import RunnerUIFooterRight from '@/components/Runner/RunnerUIFooterRight'
import { useGameState, useRunnerState } from '@/composables/useRunnerState'

import LoadingFooter from '../Loading/LoadingFooter'

export default function AppLayoutFooter() {
  const { footerCenter, footerRight } = useAppLayout()

  const { isLoading } = useRunnerState()
  const { loadingProgress } = useGameState(['loadingProgress'])

  const isTouch = 'ontouchstart' in window

  return (
    <footer
      className={`Footer fixed z-100 bottom-0 left-0 w-full p-16 pointer-events-none items-end grid [grid-template-areas:'center_center''left_right'] md:[grid-template-areas:'left_center_right'] md:grid-cols-[1fr_2fr_1fr]`}
    >
      <div className={`Footer__Left *:pointer-events-auto [grid-area:left] flex justify-start`}>
        <div className={`${isTouch ? 'hidden' : ''}`}>
          <SoundButton />
        </div>
      </div>
      <div ref={footerCenter} className='Footer__Center *:pointer-events-auto [grid-area:center] flex justify-center'>
        <LoadingFooter isVisible={isLoading} progress={loadingProgress} />
      </div>
      <div className='Footer__Right *:pointer-events-auto [grid-area:right]'>
        <div className='flex justify-end' ref={footerRight}></div>
        <RunnerUIFooterRight />
      </div>
    </footer>
  )
}
